import React__default, { useMemo } from 'react';
import FALLBACK_LOCALIZED_TEXT from '../../48dadcd56cf7616582623724c76363e2fb04ae1fe9d220ce934d6b68d1442aa3.cfe-internal.js';
import '../createContextUtilities/849fab54d7a821eeafd2c4e0244d34d6a384b57f34cbf0617e0253b2c4ade8b3.cfe-internal.js';
import createContextUtilities from '../createContextUtilities/75e5580757e6f68807f92e07850cfc0605a5ff6677179fbc573cffe4ac0a5df9.cfe-internal.js';

var fallbackLocalizedText = FALLBACK_LOCALIZED_TEXT;
var _createContextUtiliti = createContextUtilities({
    localizedText: {}
  }),
  TranslationContextProvider = _createContextUtiliti.Provider,
  useTranslationContext = _createContextUtiliti.useContext;
var TranslationProvider = function TranslationProvider(_ref) {
  var localizedText = _ref.localizedText,
    children = _ref.children;
  var translationContext = useMemo(function () {
    return {
      localizedText: localizedText
    };
  }, [localizedText]);
  return /*#__PURE__*/React__default.createElement(TranslationContextProvider, {
    value: translationContext
  }, children);
};

export { TranslationProvider, fallbackLocalizedText, useTranslationContext };
